import { Timesheets } from '../../types/timers'
import { useExpenses } from '../../store/useExpenses'
import { Expense, Expenses } from '../../types/expenses'
import { storeToRefs } from 'pinia'
import { grabDatesFromTimesheets } from './utils'

/**
 * Expenses from timecards will be saved by the date of the timecard (i.e.
 * overwritten for a particular date). Since we're grabbing timecards
 * since last synced, this will populate fresh logins w/ expense
 * data, and any timecards that come back should be up to date
 * with backdated expenses.
 */
export const saveExpensesFromTimecards = (data: Timesheets): void => {
  const { getAllExpenses } = storeToRefs(useExpenses())
  const { saveExpenses } = useExpenses()

  //Here we need to sync up expenses per date
  const dates = grabDatesFromTimesheets(data)

  //Expenses with dates that are not in the dates from the timecards
  const filteredExpenses = getAllExpenses.value.filter((expense) => {
    return !dates.some((date) => {
      return (
        date.getDate() === expense.date.getDate() && date.getMonth() === expense.date.getMonth()
      )
    })
  })

  const newData = [...filteredExpenses, ...grabExpensesFromTimesheets(data)]
  saveExpenses(newData)
}

const grabExpensesFromTimesheets = (data: Timesheets): Expenses => {
  return data
    .flatMap((timesheet) => JSON.parse(timesheet.expensesData as unknown as string))
    .filter((expense: Expense | null) => expense)
}
